// src/redux/actions.ts
export const SELECT_IMAGES = 'COMMON/SELECT_IMAGES';
export const UPLOAD_IMAGE_REQUEST = 'COMMON/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'COMMON/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'COMMON/UPLOAD_IMAGE_FAILURE';
export const REMOVE_IMAGE = 'COMMON/REMOVE_IMAGE';
export const RESET_IMAGES = 'COMMON/RESET_IMAGES';

export enum ImageTypeEnums {
  USER = 'USER',
  RECIPE_DETAIL = 'RECIPE_DETAIL',
  INGREDIENT = 'INGREDIENT',
  TEMPORARY = 'TEMPORARY',
  COMMUNITY = 'COMMUNITY',
}

export enum OpenImagePickerType {
  GALLERY = 'GALLERY',
  CAMERA = 'CAMERA',
}

export interface ISelectedImage {
  id?: number;
  uuid: string;
  type: ImageTypeEnums; // USER,RECIPE_DETAIL,INGREDIENT,TEMPORARY
  file: File;
  src: string;
  name: string;
  uploading?: boolean;
  error?: Error | null;
  uploadType: 'SERVER' | 'UPLOAD';
  openType?: OpenImagePickerType;
  url?: {
    thumbnail: string;
    original: string;
    small: string;
    medium: string;
  };
}

export interface SelectImagesAction {
  type: typeof SELECT_IMAGES;
  payload: ISelectedImage | ISelectedImage[];
}

export interface UploadImageRequestAction {
  type: typeof UPLOAD_IMAGE_REQUEST;
  payload: ISelectedImage;
}

export interface UploadImageSuccessAction {
  type: typeof UPLOAD_IMAGE_SUCCESS;
  payload: any;
}

export interface UploadImageFailureAction {
  type: typeof UPLOAD_IMAGE_FAILURE;
  payload: { file: any, error?: Error };
}

export type ImageActions =
  | SelectImagesAction
  | UploadImageRequestAction
  | UploadImageSuccessAction
  | UploadImageFailureAction;

export const selectImages = (files: ISelectedImage | ISelectedImage[]): SelectImagesAction => ({
  type: SELECT_IMAGES,
  payload: files,
});

export const uploadImageRequest = (file: ISelectedImage): UploadImageRequestAction => ({
  type: UPLOAD_IMAGE_REQUEST,
  payload: file,
});

export const uploadImageSuccess = (file: any): UploadImageSuccessAction => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: file,
});

export const uploadImageFailure = (file: any, error?: Error): UploadImageFailureAction => ({
  type: UPLOAD_IMAGE_FAILURE,
  payload: { file, error },
});

export const removeImage = (uuid: string) => ({
  type: REMOVE_IMAGE,
  payload: { uuid },
});

export const resetImages = () => ({
  type: RESET_IMAGES,
});
